import Vue from 'vue'
import VueRouter from 'vue-router'
import eventBus from '../utils/eventbus'

import activityRoutes from './activity'
import deprecatedRoutes from './deprecated.js'
import docsRoutes from './docs'
import downloadRoutes from './download'

const Home = () => import('../views/Home')

// echo 支付页面
const EchoPay = () => import(/* webpackChunkName:"chunk-echopay" */ '../views/Echo/Pay')
const EchoPayStore = () => import(/* webpackChunkName:"chunk-echopay" */ '../views/Echo/PayStore')

// P1_Boys ↓
const Pay = () => import(/* webpackChunkName:"chunk-pay" */ '../views/P1_Boys/Pay')
const PayNext = () => import(/* webpackChunkName:"chunk-pay" */ '../views/P1_Boys/PayNext')
const PayStore = () => import(/* webpackChunkName:"chunk-pay" */ '../views/P1_Boys/PayStore')
const PayCode = () => import(/* webpackChunkName:"chunk-paycode" */ '../views/P1_Boys/PayCode')
const PayResult = () => import(/* webpackChunkName:"chunk-payres" */ '../views/P1_Boys/PayResult')
const PayThirdBack = () => import(/* webpackChunkName:"chunk-payres" */ '../views/P1_Boys/PayThirdBack')
// P1_Boys ↑

// P1_Girls ↓
const Check = () => import(/* webpackChunkName:"chunk-checkperformance" */'../views/P1_Girls/CheckPerformance')

const HostessCenter = () => import(/* webpackChunkName:"chunk-hostessCenter" */ '../views/P1_Girls/HostessCenter')

const HostessRank = () => import(/* webpackChunkName:"chunk-hostessRank" */ '../views/P1_Girls/HostessRank/index.vue')
const HostessRankRule = () => import(/* webpackChunkName:"chunk-hostessRank" */ '../views/P1_Girls/HostessRank/rule.vue')

const HostessTasks = () => import(/* webpackChunkName:"chunk-hostessTasks" */ '../views/P1_Girls/HostessTasks')

const MyBeans = () => import(/* webpackChunkName:"chunk-myBeans" */ '../views/P1_Girls/MyBeans')
const MyBeansDetails = () => import(/* webpackChunkName:"chunk-myBeans" */ '../views/P1_Girls/MyBeans/MyBeansDetails.vue')
const MyBeansReport = () => import(/* webpackChunkName:"chunk-myBeans" */ '../views/P1_Girls/MyBeans/Report.vue')
const ReportDetails = () => import(/* webpackChunkName:"chunk-myBeans" */ '../views/P1_Girls/MyBeans/ReportDetails.vue')

const Withdrawal = () => import(/* webpackChunkName:"chunk-withdrawal" */ '../views/P1_Girls/Withdrawal')
const instantPayment = () => import(/* webpackChunkName:"chunk-withdrawalpayment" */'../views/P1_Girls/Withdrawal/instantPayment.vue')
const WithdrawalAccount = () => import(/* webpackChunkName:"chunk-withdrawalaccount" */ '../views/P1_Girls/WithdrawalAccount')
const BindWithdrawal = () => import(/* webpackChunkName:"chunk-bindwithdrawal" */ '../views/P1_Girls/WithdrawalBind')
const WithdrawalDetailsStatus = () => import(/* webpackChunkName:"chunk-withdrawaldetail" */'../views/P1_Girls/WithdrawalDetails/detailsStatus.vue')
const WithdrawalDetails = () => import(/* webpackChunkName:"chunk-withdrawaldetail" */ '../views/P1_Girls/WithdrawalDetails')
// P1_Girls ↑

// P2 ↓
const BecomeAgent = () => import(/* webpackChunkName:"chunk-becomeagent" */'../views/P2_Page/BecomeAgent')
const CustomerService = () => import(/* webpackChunkName:"chunk-customerservice" */'../views/P2_Page/CustomerService')
const DynamicPolicy = () => import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/DynamicPolicy/index.vue')

const FriendshipLevel = () => import(/* webpackChunkName:"chunk-friendship" */'../views/P2_Page/FriendshipLevel')
const FriendshipLevelRule = () => import(/* webpackChunkName:"chunk-friendship" */'../views/P2_Page/FriendshipLevel/intimateRule.vue')

const Invite = () => import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/Invite/index.vue')
const Performance = () => import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/Invite/Performance.vue')
const InviteVRules = () => import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/Invite/Rules.vue')
const InviteHistory = () => import(/* webpackChunkName:"chunk-invite" */ '../views/P2_Page/InviteHistory')

const SevenKeepSignin = () => import(/* webpackChunkName:"chunk-sevenkeepsignin" */'../views/P2_Page/SevenKeepSignin')
const SevenKeepSigninRule = () => import(/* webpackChunkName:"chunk-sevenkeepsignin" */'../views/P2_Page/SevenKeepSignin/Rules')

const Violation = () => import(/* webpackChunkName:"chunk-violation" */'../views/P2_Page/Violation')
// P2 ↑

// P3 ↓
const GoPartyPrivacy = () => import(/* webpackChunkName:"chunk-docs" */'../views/P3_Page/GoPartyPrivacy')
const GoPartyUser = () => import(/* webpackChunkName:"chunk-docs" */'../views/P3_Page/GoPartyUser')

const JoyLinkPrivacy = () => import(/* webpackChunkName:"chunk-docs" */'../views/P3_Page/JoyLinkPrivacy')
const JoyLinkUser = () => import(/* webpackChunkName:"chunk-docs" */'../views/P3_Page/JoyLinkUser')

const joychatPrivacy = () => import(/* webpackChunkName:"chunk-docs" */'../views/P3_Page/JoychatPrivacy')
const joychatUser = () => import(/* webpackChunkName:"chunk-docs" */'../views/P3_Page/JoychatUser')

const PrivacyAgreement = () => import(/* webpackChunkName:"chunk-docs" */'../views/P3_Page/PrivacyAgreement')
const UserAgreement = () => import(/* webpackChunkName:"chunk-docs" */'../views/P3_Page/UserAgreement')
// P3 ↑

// P4 ↓
const RulesHostess = () => import(/* webpackChunkName:"chunk-allrules" */'../views/P4_Page/BaseRules/rules-hostess.vue')
const RulesUser = () => import(/* webpackChunkName:"chunk-allrules" */'../views/P4_Page/BaseRules/rules-user.vue')
const EarningRules = () => import(/* webpackChunkName:"chunk-allrules" */'../views/P4_Page/EarningRules')
const FAQ = () => import(/* webpackChunkName:"chunk-allrules" */'../views/P4_Page/FAQ')
const LevelRatio = () => import(/* webpackChunkName:"chunk-allrules" */'../views/P4_Page/LevelRatio')
// P4 ↑

// P5 ↓
const MatchingToPay = () => import(/* webpackChunkName:"chunk-matchtopay" */'../views/P5_Activitys/MatchingToPay')
// P5 ↑

Vue.use(VueRouter)

const routes = [
  {
    path: '/home', name: 'home', component: Home
  },
  // echo
  {
    path: '/echo-pay', name: 'echo-pay', component: EchoPay
  },
  {
    path: '/echo-pay-store', name: 'echo-pay-store', component: EchoPayStore
  },
  // P1_Boys
  {
    path: '/pay', name: 'Pay', component: Pay
  },
  {
    path: '/pay-v2', name: 'PayNext', component: PayNext
  },
  {
    path: '/buy-coins', name: 'buy-coins', component: PayStore
  },
  {
    path: '/pay-code', name: 'pay-code', component: PayCode
  },
  {
    path: '/pay-result', name: 'pay-result', component: PayResult
  },
  {
    path: '/pay-third-back', name: 'pay-third-back', component: PayThirdBack
  },
  // P1_Girls
  {
    path: '/check-performance', name: 'check-performance', component: Check
  },
  {
    path: '/hostess-center', name: 'hostess-center', component: HostessCenter
  },
  {
    path: '/hostess-rank', name: 'hostess-rank', component: HostessRank,
  },
  {
    path: '/hostess-rank-rules', name: 'hostess-rank-rules', component: HostessRankRule,
  },
  {
    path: '/hostess-tasks', name: 'hostess-tasks', component: HostessTasks
  },
  {
    path: '/my-beans', name: 'my-beans', component: MyBeans
  },
  {
    path: '/income/details', name: 'income-details', component: MyBeansDetails
  },
  {
    path: '/income/report', name: 'income-report', component: MyBeansReport
  },
  {
    path: '/income/report/details', name: 'income-report-details', component: ReportDetails
  },
  {
    path: '/withdrawal', name: 'Withdrawal', component: Withdrawal
  },
  {
    path: '/instant-payment', name: 'instant-payment', component: instantPayment
  },
  {
    path: '/withdrawal-account', name: 'WithdrawalAccount', component: WithdrawalAccount
  },
  {
    path: '/bind-withdrawal', name: 'BindWithdrawal', component: BindWithdrawal
  },
  {
    path: '/withdrawal-details', name: 'WithdrawalDetails', component: WithdrawalDetails
  },
  {
    path: '/withdrawal-details-status', name: 'withdrawal-details-status', component: WithdrawalDetailsStatus
  },
  // P2
  {
    path: '/become-agent', name: 'become-agent', component: BecomeAgent
  },
  {
    path: '/customer-service', name: 'customer-service', component: CustomerService
  },
  {
    path: '/invite-dypolicy', name: 'invite-dypolicy', component: DynamicPolicy
  },
  {
    path: '/demo/invite-dypolicy', name: 'invite-dypolicy', component: DynamicPolicy
  },
  {
    path: '/friendship-level', name: 'friendship-level', component: FriendshipLevel
  },
  {
    path: '/friendship-level-rule', name: 'friendship-level-rule', component: FriendshipLevelRule
  },
  {
    path: '/invite', name: 'invite', component: Invite,
    meta: { keepAlive: true }
  },
  {
    path: '/invite-performance', name: 'invite-performance', component: Performance
  },
  {
    path: '/invite-v2-rules', name: 'invite-v2-rules', component: InviteVRules
  },
  {
    path: '/invite-history', name: 'invite-history', component: InviteHistory
  },
  {
    path: '/seven-keep-signin', name: 'seven-keep-signin', component: SevenKeepSignin
  },
  {
    path: '/seven-keep-signin-rules', name: 'seven-keep-signin-rules', component: SevenKeepSigninRule
  },
  {
    path: '/violation-details', name: 'violation-details', component: Violation
  },
  // P3
  {
    path: '/goparty-privacy-agreement', name: 'pay-code', component: GoPartyPrivacy, meta: { title: 'Goparty' }
  },
  {
    path: '/goparty-user-agreement', name: 'pay-code', component: GoPartyUser, meta: { title: 'Goparty' }
  },
  {
    path: '/joylink-privacy-agreement', name: 'pay-code', component: JoyLinkPrivacy, meta: { title: 'Joylink' }
  },
  {
    path: '/joylink-user-agreement', name: 'pay-code', component: JoyLinkUser, meta: { title: 'Joylink' }
  },
  {
    path: '/joychat-user', name: 'joychat-user', component: joychatUser
  },
  {
    path: '/joychat-privacy', name: 'joychat-privacy', component: joychatPrivacy
  },
  {
    path: '/privacy-agreement', name: 'privacy-agreement', component: PrivacyAgreement
  },
  {
    path: '/user-agreement', name: 'user-agreement', component: UserAgreement
  },
  // P4
  {
    path: '/rules', name: 'rules-female', component: RulesHostess
  },
  {
    path: '/rules-male', name: 'rules-male', component: RulesUser
  },
  {
    path: '/earning-rules', name: 'earning-rules', component: EarningRules
  },
  {
    path: '/faq', name: 'faq', component: FAQ
  },
  {
    path: '/level-ratio', name: 'level-ratio', component: LevelRatio
  },
  // P5
  {
    path: '/matching-to-pay', name: 'matching-to-pay', component: MatchingToPay
  },

  ...activityRoutes,
  ...deprecatedRoutes,
  ...docsRoutes,
  ...downloadRoutes,
  { path: '*', redirect: '/home' }
]

// 代理中心二级页面
const limitPathsToInvite = [
  '/invite-policy',
  '/invite-v2-rules',
  '/invite-history',
  '/withdrawal',
  '/violation-details',
  '/invite-performance'
]

// 9.99活动
// const limitPathsToAct18 = ['/pay', '/echo-pay']

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/invite' && limitPathsToInvite.includes(from.path)) {
    eventBus.$emit('refreshInvitePage')
  }

  // if (to.path === '/recharge-ninepointninety' && limitPathsToAct18.includes(from.path)) {
  //   eventBus.$emit('refreshAct18')
  // }

  window.scrollTo(0, 0)
  next()
})

// 路由
export default router
